export const cruiseCode = "SS280506010"
